import script from "./OpacityControl.vue?vue&type=script&lang=js"
export * from "./OpacityControl.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__